import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminPromoCodeComponent } from './admin-promo-code.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PromoCodeModule } from '../../../../shared/promo-code/promo-code.module';

@NgModule({
  declarations: [AdminPromoCodeComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule, PromoCodeModule],
})
export class AdminPromoCodeModule {}
